import { Component, OnInit } from '@angular/core';
import { LocalStorageSettingsService } from 'src/app/shared/services/local-storage-settings.service';
import { ManagemdlscriptpopupComponent } from './managemdlscriptpopup/managemdlscriptpopup.component';
import { MatDialog } from '@angular/material/dialog';
import { UserRoutingModule } from '../user-routing/user-routing.module';
import { ReportlinksserviceService } from '../reportlinks/reportlinksservice.service';
import { Actionbutton } from 'src/app/shared/common/Actionbutton';
import { CommonService } from 'src/app/shared/services/common.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NgxUiLoaderService } from 'ngx-ui-loader';

@Component({
    selector: 'app-managemdlscript',
    templateUrl: './managemdlscript.component.html',
    styleUrls: ['./managemdlscript.component.scss'],
    standalone: false
})
export class ManagemdlscriptComponent implements OnInit {
    columnDefs
    defaultColDef
    paginationPageSize
    paginationNumberFormatter
    rowClassRules
    backgroundColor  
    backgroundColorScreen
    gridApi
    lastpage
    currentpage
    nextpage
    nextpageplusone
    totalpages
    pagesize
    buttonColor
    buttonName
    bootstrapColumn
    buttonIdList = []
  getRowStyle: (params: any) => { backgroundColor: string; };
  excelData: any;
  dnsId: string;
  tableName: string;
  components
  getdata


  constructor(private localStorrageSettings:LocalStorageSettingsService,private dialog: MatDialog,private userRoutingModule: UserRoutingModule,
       private reportLinkService:ReportlinksserviceService,private commonService: CommonService,private snackbar:MatSnackBar,private spinner:NgxUiLoaderService) { 
        this.components ={
             buttonRenderer: Actionbutton,
           }
       }

  ngOnInit(): void {
      this.tableName= 'managemdlscript'
      this.dnsId = this.localStorrageSettings.getSettings("dnsName")
      let screenPath = this.userRoutingModule.print(this.constructor.name);
      console.log(screenPath);
      this.reportLinkService.screenoperationspermission(screenPath,this.localStorrageSettings.getSettings('UserId')).subscribe(res => {
      console.log(res);
      let responsedata: any ;
      responsedata = res;
      for (let i = 0; i <responsedata.length ; i++) {
        
       this.buttonIdList.push(responsedata[i].buttonId);
       }
    
       this.buttonIdList.push('screen');
       console.log('Button ID List:', this.buttonIdList);
       const buttons = document.querySelectorAll('button'); // Select all buttons in the DOM
       buttons.forEach(button => {
       const buttonId = parseInt(button.getAttribute('id'), 10); // Get the button's id
       if (!isNaN(buttonId)) { // Only process buttons with a valid numeric id
         if (!this.buttonIdList.includes(buttonId)) {
             button.setAttribute('disabled', 'true'); // Disable the button
         } else {
             button.removeAttribute('disabled'); // Enable the button
         }
       }
       });
 
     });
    this.defaultColDef = {
filterParams: {
        maxNumConditions: 2,
        numAlwaysVisibleConditions: 2,
        defaultJoinOperator: 'OR'
      },
      sortable: true,
      resizable: true,
      filter: true
    };
    this.columnDefs = [{
      headerName: 'Action', filter: false, cellRenderer: 'buttonRenderer',
      pinned:'left',
      lockPinned:true,
      cellRendererParams: {
        values:this.buttonIdList,
        edit: this.editIcon.bind(this),
        delete: this.deleteIcon.bind(this),
      }, width: 150
    },
     { headerName: 'Id', headerTooltip: 'Id', tooltipValueGetter: (params) => 'Id : ' + params.value, field: 'managemdlscriptId', filter: 'agTextColumnFilter', width: 150 },
      { headerName: 'Property Category', headerTooltip: 'Property Category', tooltipValueGetter: (params) => 'Property Category : ' + params.value, field: 'propertycategory', filter: 'agTextColumnFilter', width: 350 },
      { headerName: 'Property Name', headerTooltip: 'Property Name', tooltipValueGetter: (params) => 'Property Name : ' + params.value, field: 'propertyname', filter: 'agTextColumnFilter', width: 250 },
      { headerName: 'Component Type', headerTooltip: 'Component Type', tooltipValueGetter: (params) => 'Component Type : ' + params.value, field: 'component_type', filter: 'agTextColumnFilter', width: 250 },
      { headerName: 'Create Template', headerTooltip: 'Create Template', tooltipValueGetter: (params) => 'Create Template : ' + params.value, field: 'createmdltemplate', filter: 'agTextColumnFilter', width: 250 },
      { headerName: 'Update Template', headerTooltip: 'Update Template', tooltipValueGetter: (params) => 'Update Template: ' + params.value, field: 'updatemdltemplate', filter: 'agTextColumnFilter', width: 250 },
      { headerName: 'Executable', headerTooltip: 'Executable', tooltipValueGetter: (params) => 'Executable" : ' + params.value, field: 'isexecutable', filter: 'agTextColumnFilter', width: 250 },
            { headerName: 'Execution Order', headerTooltip: 'Execution Order', tooltipValueGetter: (params) => 'Execution Order" : ' + params.value, field: 'executionorder', filter: 'agTextColumnFilter', width: 250 },

      { headerName: 'Status', headerTooltip: 'Status', tooltipValueGetter: (params) => 'Status : ' + params.value, field: 'status', filter: 'agTextColumnFilter', width: 250,   
        cellStyle: function (params){
          if (params.value == 'Yes'){
            return { color: 'green' };
          } else {
            return { color: 'red' };
          }
        } 
      },
      
    ],

    this.getRowStyle = (params: any) => {
      console.log(params)
      console.log(params.data.status)
      if (params.data.status === 'No') {
        return { backgroundColor: 'rgb(211, 211, 211)' };
      }
    };
    this.buttonColor = this.localStorrageSettings.getSettings("ColorA")
    this.backgroundColorScreen = this.localStorrageSettings.getSettings("ColorD")

  }

  onBtExport() {
    this.gridApi.api.exportDataAsCsv();
  }

  //pagination code
  onPaginationChanged() {
    if (this.gridApi.api) {
      this.lastpage = this.gridApi.api.paginationIsLastPageFound();
      this.currentpage = this.gridApi.api.paginationGetCurrentPage() + 1
      this.nextpage = this.gridApi.api.paginationGetCurrentPage() + 1 + 1
      this.nextpageplusone = this.gridApi.api.paginationGetCurrentPage() + 1 + 1 + 1
      this.totalpages = this.gridApi.api.paginationGetTotalPages()
    }
  }
  //this function is for going to the given page number 
  onSearchChange(searchValue: number) {

    this.gridApi.api.paginationGoToPage(searchValue - 1);
  }

  // below function is for changing the no of rows per page
  onPageSizeChanged() {
    var value = this.pagesize
    this.gridApi.api.setGridOption('paginationPageSize', Number(value));
  }

  // below function is for going to next page
  onBtNext() {
    console.log("next")
    this.gridApi.api.paginationGoToNextPage();
  }

  // below function for going to previous page
  onBtPrevious() {
    console.log("previous")
    this.gridApi.api.paginationGoToPreviousPage();
  }

  // below function for going to first page
  onBtFirst() {
    console.log("first")
    this.gridApi.api.paginationGoToFirstPage();
  }

  // below function for going to last page
  onBtLast() {
    console.log("last")
    this.gridApi.api.paginationGoToLastPage();
  }
  openSaveForm(buttonName) {
     this.buttonName = buttonName;
    
     let width = '80%';
 
     if (this.bootstrapColumn == 1) {
 
       width = '55%';
 
     }
     var obj={}
     let dialogRef = this.dialog.open(ManagemdlscriptpopupComponent, {
       panelClass: 'custom-dialog-container-materialFulfilment',
       width: '60%',
       // height:'100%',
       autoFocus: false,
       data: { edata: obj},
       disableClose: true,
     });
 
     // subcribe the popup after close
     dialogRef.afterClosed().subscribe(result => {
 
      if (this.gridApi) {
       this.onGridReady(this.gridApi);
     }
     });
     
   }
     onGridReady(params){
     this.gridApi = params;
     params.api.setGridOption('rowData', [])
     var tenantId = localStorage.getItem('dnsName');
     console.log(tenantId)
     this.retrieve(tenantId)
   }

    editIcon(e) {
            let rowData = e.rowData;
            console.log(e.rowData);
            console.log(e.rowData);
            var obj = e.rowData
            console.log(obj);
            console.log(event);
            if(e.rowData.status === "No"){
              this.snackbar.open("Selected record is already deleted","OK",{duration:5000});
              return;
            }
            let dialogRef = this.dialog.open(ManagemdlscriptpopupComponent, {
              panelClass: 'custom-dialog-container-materialFulfilment',
              width: '60%',
              autoFocus: false,
              data: { edata: obj},
              disableClose: true,
            });
        
            dialogRef.afterClosed().subscribe(result=>{
              if (this.gridApi) {
                this.onGridReady(this.gridApi); // Call onGridReady after the popup closes
            }
            })
        
          }
    deleteIcon(event) {
      console.log(event);
      if(event.rowData.status === "No"){
      this.snackbar.open("Selected record is already deleted","OK",{duration:5000});
      return;
      }
      if(confirm("Are you sure you want to delete this record?")){
       this.spinner.start();
       this.commonService.deleteMdlScript(event.rowData.managemdlscriptId).subscribe(result=>{
        if(result.statusMessage === "Successfully record is deleted"){
          this.snackbar.open(result.statusMessage, "OK",{duration:5000});
        }else{
          this.snackbar.open("Cannot delete selected record", "OK",{duration:5000});
        }
        this.retrieve(1);
        this.spinner.stop();
        });
      }
    
    }

    retrieve(tenantId){
      console.log("inside retrival")
      this.commonService.retrieveManageMdlScript().subscribe(response=>{
      if(response.error == true){
        this.spinner.stop();
        this.snackbar.open(response.statusMessage, "OK", {
          duration: 5000,
        });
        this.getdata = null;
        this.gridApi.api.setGridOption('rowData', this.getdata)
      }else{
        console.log(response)
        this.getdata = response
        console.log(this.getdata)
        this.gridApi.api.setGridOption('rowData', this.getdata)
        this.spinner.stop();
      }
     
      })
    }

}
